import React, { Component, } from 'react'

import PropTypes from 'prop-types';

import {ImageUtils, CCIcon, CCDp} from './../../cc-imports'
// import './cc-entry-summary-item.css'
import './../../styles/css/components/CCEntrySummaryItem/cc-entry-summary-item.css'


class CCEntrySummaryItem extends Component {

    static propTypes = {
        entry : PropTypes.object,

        onPress:PropTypes.func,
        onLongPress:PropTypes.func,

        size : PropTypes.string,
        disabled : PropTypes.bool,

        placeholder: PropTypes.bool,
        placeholderText : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

        firstText : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        secondText : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    };

    static defaultProps = {
        entry:{},

        onPress : ()=>{},
        onLongPress : ()=>{},

        size : 'r',
        disabled : false,

        placeholder : false,
        placeholderText : undefined, PropTypes,

        firstText : undefined,
        secondText: undefined,
    };

    constructor(props) {
        super(props)
        this.state = {}

        this._getDimensions=this._getDimensions.bind(this);
        this._getTexts=this._getTexts.bind(this);
    }

    _getDimensions(){
        var dim = { height:60, width:60, firstTxtSize : 14, secondTxtSize: 12, thirdTextSize :12};
        switch (this.props.size){
            case 's':
                //TODO: Implement when required
                dim = { height:60, width:60, firstTxtSize : 14, secondTxtSize: 12, thirdTextSize:12};
                break;
            case 'r':
                dim = { height:70, width:70, firstTxtSize : 14, secondTxtSize: 12, thirdTextSize:10};
                break;
            default:
                dim = { height:60, width:60, firstTxtSize : 14, secondTxtSize: 12, thirdTextSize:12};
        }
        return dim;
    }

    _getTexts(){
        const dimension=this._getDimensions();
        const {entry, placeholder, firstText, secondText, thirdText} = this.props;

        if(!placeholder){
            return(
                <div className={"flex-container cc-entry-container"}>
                    {
                        firstText!==undefined &&
                        <h1 className={'entry-summary-dp-txt2'} >{firstText}</h1>
                    }
                    {
                        secondText!==undefined &&
                        <h3 className={'entry-summary-dp-txt2'}>{secondText}</h3>
                    }
                </div>)
        }
    }



    render() {
        let {entry, onLongPress, onPress, size, disabled, placeholder, placeholderText} = this.props;
        let dimension = this._getDimensions();

        let image = ImageUtils.getProfilePicSrc(entry.creator.id);


        //console.log(this.props)

        return (
            <div className="flex-container  cc-entry-summary-container" onClick={this.props.onPress}>
                <div className="flex-container " style={{opacity: disabled ? 0.5 : 1 ,flexDirection : 'column', alignItems : 'center'}}>
                        {
                            !placeholder &&
                            <CCDp user={entry.creator} imgClass={'entry-summary-dp'}/>
                        }
                        {
                            this._getTexts(placeholder, dimension, entry)
                        }
                        {
                            !placeholder &&
                            <div className={'cc-entry-extras-container'}>
                                {
                                    entry.winning &&
                                    <CCIcon className={'cc_league_icon'}  type={'winBanner'} style={{alignItems:'flex-end'}}/>
                                }
                                {
                                    entry.rewarded &&
                                    <CCIcon className={'cc_league_icon'}  type={'rewardBanner'} style={{alignItems:'flex-end'}}/>
                                }
                            </div>
                        }
                </div>
                {
                    placeholder &&
                    <div className={'cc-entry-summary-placeholder-parent '} >
                        <div className={"flex-container cc-entry-summary-dp-more"}>
                            <h1 className={'cc-entry-summary-placeholder-txt'} >{placeholderText}</h1>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default CCEntrySummaryItem


// WEBPACK FOOTER //
// ./src/app/components/CCEntrySummaryItem/CCEntrySummaryItem.js